export default {
  'footer:social-title': "Don't miss out on news & deals!",
  'footer:newsletter-title':
    'Sign up for our newsletter and grab your 15% voucher.',
  'footer:newsletter-input-placeholder': 'Your email address',
  'footer:newsletter-button-cat': 'Cat fan',
  'footer:newsletter-button-dog': 'Dog fan',
  'footer:newsletter-unsubscribe-notice':
    'Voucher valid for your first order only. {br} By signing up, you agree to our <a>Privacy Policy</a>. {br} <strong>You can unsubscribe at any time.</strong>',
  'footer:newsletter-main-title': 'Newsletter',
  'footer:newsletter-petsdeli-hashtag': '#petsdelifamily',
  'footer:social-facebook': 'Facebook',
  'footer:social-instagram': 'Instagram',
  'footer:social-ambassador-program': 'Become a brand ambassador',

  'footer:title-valuable': 'Good to know',
  'footer:title-good-for-you': 'Goodies for you',
  'footer:title-help': 'Help',
  'footer:title-shipping': 'Reliable delivery with',
  'footer:title-payment': 'Pay with',
  'footer:title-legal': 'Pets Deli',
  'footer:help-title':
    "Questions? Bring them on! We're happy to help you and your furry friend.",
  'footer:newsletter-thank-you':
    "Thanks for signing up! {br} We've sent you a confirmation email.",
  'footer:refer-friend:title':
    '{amount} for you, {amountFriend} for your friend',
  'footer:refer-friend:subtitle': 'how it works',

  'footer:refer-friend:steps:copy-link': 'Share Pets Deli with your friends',
  'footer:refer-friend:steps:share-with-friend':
    'Your friend will automatically receive a {amountFriend} discount on their first order.',
  'footer:refer-friend:steps:result':
    "You'll receive your {amount} credit once your friend places their first order.",

  'footer:link-section:opening-hours': 'Mon-Fri, 9am-6pm',
  'footer:link-section:link-help': 'Need help?',
  'footer:link-section:customer-support-phone-number': '+49 30-22 05 6 44 05',
  'footer:link-section:whatsapp-number': '+49 30 33083819',
  'footer:link-section:language-switcher': 'Language',
};
